window.onload = function() {

    initCustomScripts();
    
    window.addEventListener('resize', function() {
      initializeTooltipPositions();
    });
  
};

    
    // Tooltip Functionality
    window.themeTranslations = {
      'general.tooltips.tooltip1': "Bacopa monnieri bevordert de concentratie en het geheugen",
      'general.tooltips.tooltip2': "Camellia sinensis draagt bij tot het vinden van meer energie door ondersteuning van de mentale en fysieke capaciteiten",
      'general.tooltips.tooltip3': "Bacopa monnieri bevordert de concentratie en het geheugen \u0026amp; Camellia sinensis draagt bij tot het vinden van meer energie door ondersteuning van de mentale en fysieke capaciteiten",
      'general.tooltips.tooltip4': "Valeriaan is goed voor de nachtrust",
      'general.tooltips.tooltip5': "Passiebloem helpt om uitgerust wakker te worden",
      'general.tooltips.tooltip6': "Valeriaan en passiebloem helpen bij het bevorderen van de slaapbereidheid",
      'general.tooltips.tooltip7': "Magnesium is goed voor gemoedstoestand \u0026amp; Valeriaan is goed voor de nachtrust",
      'general.tooltips.tooltip8': "Magnesium is goed voor gemoedstoestand",
      'general.tooltips.tooltip9': "Citroenmelisse werkt ontspannend en rustgevend",
      'general.tooltips.tooltip10': "We bieden een retour- of omruilbeleid van 14 dagen aan als je om welke reden dan ook niet tevreden bent met je bestelling.",
    };

    function getTranslation(key) {
      return window.themeTranslations[key] || 'Tooltip not defined for this marker.';
    }

    function replacePlaceholders() {

      var tooltipElements = getNodesThatContain("[tooltip");
      if(tooltipElements != null && tooltipElements.length > 0) {

        $.each(tooltipElements, function (i, el) {
            const replacedToolTipHTML = $(el).html().replace(/\[tooltip(\d+)\]/g, (match, p1) => {
              const tooltipText = getTranslation('general.tooltips.tooltip' + p1);
              return `<span class="info-icon-wrapper">
                        <span class="info-icon">
                          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                            <g>
                              <path fill="#000000" d="M322.4,173.9l-129,16.2l-4.6,21.4l25.3,4.7c16.5,3.9,19.8,9.9,16.2,26.4l-41.5,195.3c-10.9,50.5,5.9,74.3,45.5,74.3 c30.7,0,66.3-14.2,82.5-33.6l4.9-23.4c-11.3,9.9-27.7,13.9-38.6,13.9c-15.5,0-21.1-10.9-17.1-30L322.4,173.9z"/>
                              <circle fill="#000000" cx="270.1" cy="56.3" r="56.3"/>
                            </g>
                          </svg>
                        </span>
                        <span class="info-hover">${tooltipText}</span>
                      </span>`;
            });
            $(el).html(replacedToolTipHTML);
        });
      }
    }

    function getNodesThatContain(text) {
        var textNodes = $(document).find("p, span, li, h1, h2, h3, h4, h5, h6, div, a")
          .contents().filter( 
              function() {
               return this.nodeType == 3 
                 && this.textContent.indexOf(text) > -1;
        });
        return textNodes.parent();
    };

    function adjustTooltipPosition(tooltip) {
      const tooltipRect = tooltip.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const infoIconWrapper = tooltip.closest('.info-icon-wrapper');
      const iconRect = infoIconWrapper.getBoundingClientRect();
    
      // Default align to the right
      tooltip.style.left = 'auto';
      tooltip.style.right = '0';
      tooltip.style.transform = 'translateX(0)';
    
      // Check if the tooltip goes off the right side of the screen
      if (iconRect.right - tooltipRect.width < 0) {
        tooltip.style.left = '0';
        tooltip.style.right = 'auto';
        tooltip.style.transform = 'translateX(0)';
      }
    }

    function getMaxZIndex() {
      const elements = document.getElementsByTagName('*');
      let maxZ = 0;
      for (let i = 0; i < elements.length; i++) {
        const zIndex = window.getComputedStyle(elements[i]).zIndex;
        if (zIndex && zIndex !== 'auto') {
          maxZ = Math.max(maxZ, parseInt(zIndex));
        }
      }
      return maxZ;
    }

    function setHighestZIndex(element) {
      const maxZ = getMaxZIndex();
      element.style.zIndex = maxZ + 1;
    }

    function initializeTooltipPositions() {
      const tooltips = document.querySelectorAll('.info-hover');
      tooltips.forEach(tooltip => {
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        adjustTooltipPosition(tooltip);
        tooltip.style.visibility = 'hidden';
        tooltip.style.opacity = '0';
      });
    }

    function showTooltip(event) {
      const infoIcon = event.target.closest('.info-icon-wrapper');
      if (infoIcon) {
        const infoHover = infoIcon.querySelector('.info-hover');
        if (infoHover) {
          setHighestZIndex(infoHover);
          infoHover.style.visibility = 'visible';
          infoHover.style.opacity = 1;
          adjustTooltipPosition(infoHover);
        }
      }
    }

    function hideTooltip(event) {
      const infoIcon = event.target.closest('.info-icon-wrapper');
      if (infoIcon) {
        const infoHover = infoIcon.querySelector('.info-hover');
        if (infoHover) {
          infoHover.style.visibility = 'hidden';
          infoHover.style.opacity = 0;
        }
      }
    }

    function hideAllTooltips() {
      document.querySelectorAll('.info-hover').forEach(infoHover => {
        infoHover.style.visibility = 'hidden';
        infoHover.style.opacity = 0;
      });
    }

    function toggleTooltip(event) {
      const infoIcon = event.target.closest('.info-icon-wrapper');
      if (infoIcon) {
        const infoHover = infoIcon.querySelector('.info-hover');
        if (infoHover.style.visibility === 'visible') {
          hideTooltip(event);
        } else {
          hideAllTooltips();
          showTooltip(event);
        }
      } else {
        hideAllTooltips();
      }
    }

    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      document.body.addEventListener('touchstart', toggleTooltip, { passive: true });
    } else {
      document.body.addEventListener('mouseover', showTooltip, { passive: true });
      document.body.addEventListener('mouseout', hideTooltip, { passive: true });
      document.body.addEventListener('click', function(event) {
        const infoIcon = event.target.closest('.info-icon-wrapper');
        if (infoIcon) {
          hideAllTooltips();
          showTooltip(event);
        } else {
          hideAllTooltips();
        }
      });
    }


    function initCustomScripts() {
      replacePlaceholders();
      initializeTooltipPositions();
      initMenuDrawerEvents();
      initCommonScripts();
    }


/* Custom script - For cart drawer upsell slider - Starts */
function initCartUpsellSlider() {
         const upsellContainer = document.querySelector('.cart-drawer-upsell-container');
          if(!upsellContainer) {
            return;
          }
         const upsellSlider = upsellContainer.querySelector('.upsell-product-swiper-container');

        if (!upsellSlider) {
            return;
        }
        const defaultSettings = {
          pagination: {
            el: upsellContainer.querySelector('.swiper-pagination'),
            clickable: true
          },
          navigation: {
            nextEl: upsellContainer.querySelector('.sf-slider__controls-next'),
            prevEl: upsellContainer.querySelector('.sf-slider__controls-prev')
          },
          autoplay:false,
          loop: false,
          slidesPerView: 1
        };
        var settings = {
          slidesPerView: 1,
          centeredSlides: true,
          slideToClickedSlide: true
        };
        const slider = new window.spratlyTheme.Swiper(upsellSlider, { ...defaultSettings,
          ...settings
        });
}
/* Custom script - For cart drawer upsell slider - Ends */

/* Custom script - Init Menu Drawer Custom Event - Starts */
function initMenuDrawerEvents() {
    document.body.addEventListener('click', function(event) {
        const menuDrawerCloseIcon = event.target.closest('.sf-menu-close-icon');
        if(menuDrawerCloseIcon) {
          document.querySelector('.sf-menu-wrapper').click();
        } 
      });
}
/* Custom script - Init Menu Drawer Custom Event - End */

function initCommonScripts() {
  /* Custom script - Init Main Content Spacing for mobile version - Starts */
  setTimeout(function(){
    if(window.innerWidth <= 767) {
    var sfHeaderMobile = document.querySelector(".sf-header__mobile.sf-header__mobile-custom-padding");
    if(sfHeaderMobile != null) {
        document.querySelector("#MainContent").style.paddingTop = sfHeaderMobile.getBoundingClientRect().height + "px";
      }
    }
  }, 500);
  /* Custom script - Init Main Content Spacing for mobile version - Ends */
}